import {IAnalyticEvent} from "services-comun-meteored/modules/services/cmp/web/analytic-event";
import {IPostRegister} from "services-comun-meteored/modules/services/cmp/web/analytic-event";
import {log} from "../../util/log";

declare var TEST: boolean;
declare var DESARROLLO: boolean;

const SERVICIO: string = `https://${DESARROLLO ? `local-` : `${TEST ? 'test-' : ''}`}cmp.meteored.com/cmp/web/events/analytic/register`;

class EventQueue {
    /* STATIC */

    /* INSTANCE */

    public send(event: IAnalyticEvent): void {
        this.toService(event);
    }

    private toService(data: IAnalyticEvent): void {
        const post: IPostRegister = {
            event: data
        };
        fetch(SERVICIO, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(post)
        }).catch(() => {
            log.debug(`No se ha podido registrar el evento [${data.name}, ${data.action}, ${data.tag}] en el servidor`);
        });
    }
}

const instance = new EventQueue();

export default instance;
